/* ALEPEO — Trouver mon savon d'Alep — logique du questionnaire uniquement */
(function () {
  "use strict";

  var QUESTIONS = [
    { q: "Quelques heures après le nettoyage, comment se sent votre peau ?",
      hint: "Fiez-vous à votre ressenti habituel, sans produit appliqué ensuite.",
      a: [
        { t: "Elle tiraille, elle manque de confort", s: "Sensation de peau qui tire, parfois des rougeurs passagères", v: 0 },
        { t: "Elle est confortable, ni sèche ni brillante", s: "Aucune sensation particulière", v: 1.6 },
        { t: "Elle brille légèrement sur le front et le nez", s: "Le reste du visage reste confortable", v: 2.7 },
        { t: "Elle est nettement brillante partout", s: "Un mouchoir posé sur la joue laisse une trace", v: 4 }
      ] },
    { q: "Comment votre peau accueille-t-elle un nouveau produit ?",
      hint: "Cela nous aide à calibrer l'intensité du parfum et de la mousse.",
      a: [
        { t: "Elle réagit vite", s: "Picotements ou rougeurs passagères fréquents", v: 0.4, cap: 12 },
        { t: "Elle demande un temps d'adaptation", s: "Quelques jours avant de trouver son équilibre", v: 1.6, cap: 20 },
        { t: "Elle est plutôt tolérante", s: "Peu de réactions notables", v: 2.6 },
        { t: "Elle supporte à peu près tout", s: "Je change de produit sans y penser", v: 3.4 }
      ] },
    { q: "Quel grain de peau observez-vous dans le miroir ?",
      hint: "Regardez la zone des joues et des ailes du nez à la lumière du jour.",
      a: [
        { t: "Grain fin, pores peu visibles", s: "Peau plutôt fine", v: 0.7 },
        { t: "Grain régulier", s: "Rien de marquant", v: 1.9 },
        { t: "Pores visibles sur la zone T", s: "Front, nez, menton", v: 3 },
        { t: "Imperfections passagères fréquentes", s: "Petits boutons qui apparaissent régulièrement", v: 4 }
      ] },
    { q: "Où utiliserez-vous ce savon en priorité ?",
      hint: "Un même pain peut servir partout : indiquez l'usage principal.",
      a: [
        { t: "Le visage surtout", s: "Nettoyage matin et soir", v: 1.4 },
        { t: "Le corps et les mains", s: "Douche quotidienne", v: 2.2 },
        { t: "Le visage et le corps", s: "Un seul pain pour tout", v: 2 },
        { t: "Aussi les cheveux et le cuir chevelu", s: "Usage complet", v: 3.1 }
      ] },
    { q: "Qui utilisera ce savon ?",
      hint: "Nous ajustons la teneur en laurier au plus délicat des utilisateurs.",
      a: [
        { t: "Un jeune enfant", s: "Peau très délicate", v: 0, cap: 4 },
        { t: "Toute la famille", s: "Un pain partagé dans la salle de bain", v: 1.7, cap: 20 },
        { t: "Moi, je découvre le savon d'Alep", s: "Premier pain", v: 2, cap: 30 },
        { t: "Moi, j'en utilise déjà régulièrement", s: "Je connais la matière", v: 2.8 }
      ] },
    { q: "Dans quel contexte l'utiliserez-vous surtout ?",
      hint: "Le climat et l'activité modifient les besoins de la peau au fil de l'année.",
      a: [
        { t: "L'hiver, air sec et chauffage", s: "La peau est plus inconfortable", v: 1.4, mod: -0.4 },
        { t: "Toute l'année, sans variation", s: "Climat tempéré", v: 2, mod: 0 },
        { t: "L'été, chaleur et transpiration", s: "La peau brille davantage", v: 2.6, mod: 0.4 },
        { t: "Sport quotidien ou métier salissant", s: "Douche après l'effort", v: 3.2, mod: 0.4 }
      ] }
  ];

  function init(root) {
    if (root.dataset.adxReady === "1") return;
    root.dataset.adxReady = "1";

    var q = root.querySelector("[data-adx-q]");
    var bar = root.querySelector("[data-adx-bar]");
    var count = root.querySelector("[data-adx-count]");
    var prevBtn = root.querySelector("[data-adx-prev]");
    var nextBtn = root.querySelector("[data-adx-next]");
    var res = root.querySelector("[data-adx-res]");
    var quiz = root.querySelector("[data-adx-quiz]");
    var panels = root.querySelectorAll("[data-adx-panel]");
    if (!q || !nextBtn || !res) return;

    var answers = new Array(QUESTIONS.length).fill(null);
    var cur = 0;

    function scrollToEl(el) {
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    function render() {
      var Q = QUESTIONS[cur];
      var html = '<h3>' + Q.q + '</h3><p class="adx-q__hint">' + Q.hint + '</p><div class="adx-opts">';
      Q.a.forEach(function (o, i) {
        html += '<button type="button" class="adx-opt' + (answers[cur] === i ? " is-on" : "") + '" data-i="' + i + '">' +
          '<span class="adx-opt__dot"></span><span class="adx-opt__t"><b>' + o.t + '</b><span>' + o.s + '</span></span></button>';
      });
      q.innerHTML = html + "</div>";

      count.textContent = "Question " + (cur + 1) + " / " + QUESTIONS.length;
      bar.style.width = (cur / QUESTIONS.length * 100) + "%";
      prevBtn.style.visibility = cur === 0 ? "hidden" : "visible";
      nextBtn.disabled = answers[cur] === null;
      nextBtn.textContent = cur === QUESTIONS.length - 1 ? "Voir mon résultat" : "Continuer";

      q.querySelectorAll(".adx-opt").forEach(function (b) {
        b.addEventListener("click", function () {
          answers[cur] = parseInt(b.dataset.i, 10);
          q.querySelectorAll(".adx-opt").forEach(function (x) { x.classList.remove("is-on"); });
          b.classList.add("is-on");
          nextBtn.disabled = false;
          if (cur < QUESTIONS.length - 1) setTimeout(next, 260);
        });
      });
    }

    function next() {
      if (answers[cur] === null) return;
      if (cur < QUESTIONS.length - 1) { cur++; render(); scrollToEl(quiz); }
      else compute();
    }
    function prev() { if (cur > 0) { cur--; render(); } }

    function compute() {
      var sum = 0, mod = 0, cap = 40, reason = "";
      QUESTIONS.forEach(function (Q, i) {
        var o = Q.a[answers[i]];
        sum += o.v;
        if (typeof o.mod === "number") mod += o.mod;
        if (o.cap && o.cap < cap) { cap = o.cap; reason = o.t.toLowerCase(); }
      });
      var avg = sum / QUESTIONS.length + mod;
      var pct = avg < 1.0 ? 4 : avg < 1.8 ? 12 : avg < 2.55 ? 20 : avg < 3.2 ? 30 : 40;
      var capped = false;
      if (pct > cap) { pct = cap; capped = true; }
      show(pct, capped, reason);
    }

    function show(pct, capped, reason) {
      var target = String(pct), found = null;
      panels.forEach(function (p) {
        var match = p.getAttribute("data-adx-panel") === target;
        p.hidden = !match;
        if (match) found = p;
      });
      if (found) {
        var cap = found.querySelector("[data-adx-cap]");
        if (cap) {
          if (capped) {
            cap.textContent = "Vous avez indiqué « " + reason + " » : nous limitons volontairement la teneur en laurier à " +
              pct + " % pour un nettoyage tout en douceur.";
            cap.hidden = false;
          } else { cap.hidden = true; cap.textContent = ""; }
        }
      }
      bar.style.width = "100%";
      count.textContent = "Terminé";
      res.classList.add("is-on");
      scrollToEl(res);
      if (window.dataLayer) window.dataLayer.push({ event: "alep_guide_complete", teneur: pct });
    }

    function restart() {
      answers = new Array(QUESTIONS.length).fill(null);
      cur = 0;
      res.classList.remove("is-on");
      panels.forEach(function (p) { p.hidden = true; });
      render();
      scrollToEl(quiz);
    }

    nextBtn.addEventListener("click", next);
    prevBtn.addEventListener("click", prev);
    root.querySelectorAll("[data-adx-restart]").forEach(function (b) {
      b.addEventListener("click", restart);
    });

    render();
  }

  function boot() {
    document.querySelectorAll("[data-adx-root]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
